// List of topic categories
export const categories = [
  'All',
  'Science',
  'Mathematics',
  'Humanities',
  'Social Sciences',
  'Professional',
  'Computer Science',
];

/**
 * Determines the category of a task based on its name
 * @param {string} task - The task name to categorize
 * @returns {string} - The category name
 */
export const getCategory = (task) => {
  if (task.includes('MATHEMATICS') || task.includes('STATISTICS') || task.includes('ELEMENTARY_MATHEMATICS')) 
    return 'Mathematics';
  
  if (task.includes('PHYSICS') || task.includes('CHEMISTRY') || task.includes('BIOLOGY') || 
      task.includes('ASTRONOMY') || task.includes('MEDICAL') || task.includes('ANATOMY') || 
      task.includes('VIROLOGY')) 
    return 'Science';
  
  if (task.includes('HISTORY') || task.includes('PHILOSOPHY') || task.includes('RELIGIONS')) 
    return 'Humanities';
  
  if (task.includes('ECONOMICS') || task.includes('SOCIOLOGY') || task.includes('PSYCHOLOGY') || 
      task.includes('POLITICS') || task.includes('FOREIGN_POLICY')) 
    return 'Social Sciences';
  
  if (task.includes('PROFESSIONAL') || task.includes('BUSINESS') || task.includes('LAW') || 
      task.includes('ACCOUNTING') || task.includes('MANAGEMENT') || task.includes('MARKETING')) 
    return 'Professional';
  
  if (task.includes('COMPUTER') || task.includes('MACHINE_LEARNING') || 
      task.includes('ELECTRICAL_ENGINEERING') || task.includes('SECURITY')) 
    return 'Computer Science';
  
  return 'Other';
};
